import { Lookups } from '@model';

const siteContentBaseUrl = import.meta.env.VITE_SITE_CONTENT_BASE_URL;

export const fetchLookups = async (culture: string): Promise<Lookups> => {
  return await fetch(`${siteContentBaseUrl}/lookups-${culture}.json`, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  }).then((res) => res.json());
};
